/**
 * Fiskil configuration - uses Gloss API (backend) endpoints.
 * client_id and client_secret are stored on the backend only.
 */

export interface FiskilConfig {
  url: string;
  apiStage: string;
  endpoint: {
    token: string;
    endUsers: string;
    authSession: string;
    importComplete: string;
    consents: string;
    accounts: string;
    balances: string;
    transactions: string;
    accountTransactions: string;
    syncStatus: string;
  };
  cancelUri: string;
  redirectUri: string;
}

const fiskilConfig = process.env.FISKIL as unknown as FiskilConfig;

export function getFiskilConfig(isFromGuide: boolean = false): FiskilConfig {
  const newFiskilConfig: FiskilConfig = {
    ...fiskilConfig,
    cancelUri:
      typeof window !== "undefined"
        ? `${window.location.origin}/#/manage/account?status=canceled&redirect=fiskil`
        : "",
    redirectUri:
      typeof window !== "undefined"
        ? `${window.location.origin}/#/manage/account?status=success&redirect=fiskil`
        : "",
  };

  if (isFromGuide) {
    newFiskilConfig.cancelUri =
      typeof window !== "undefined"
        ? `${window.location.origin}/#/manage/account?status=canceled&redirect=fiskil&isFromGuide=true`
        : "";
    newFiskilConfig.redirectUri =
      typeof window !== "undefined"
        ? `${window.location.origin}/#/manage/account?status=success&redirect=fiskil&isFromGuide=true`
        : "";
  }

  return newFiskilConfig;
}
